import * as React from 'react';
import {connect} from 'react-redux';
import {WithStyles, withStyles} from '@material-ui/core';
import Button from '@components/common/button/Button';
import TranslateNew from '@translate/TranslateNew';
import ChatOutlinedIcon from '@material-ui/icons/ChatOutlined';
import SendIcon from '@material-ui/icons/Send';
import { EditActionStyle } from '../EditAction.style';
import { ISchedule, IScheduleEntry } from '@app-types/websocket/schedule.types';
import { IDateRange } from '@containers/calendar/calendar.helpter';
import ChangeTimePlaceDay from '../ChangeTimePlaceDay';
import { calculateHandoverDays, applyChanges } from './DayvisitCalc';
import { schoolAgeFromFamily } from '@helpers/schoolHelper';
import { IHandoverSetting, getDefaultDays } from '../ScheduleCalc';
import { IFamilyMember } from '@app-types/websocket/family.types';
import ImgAvatar from '@components/common/avatar/ImgAvatar';
import BackArrowIcon from "@material-ui/icons/ArrowBackIosRounded";

const tn: TranslateNew = TranslateNew.getInstance();



interface IState {
  pickupParentA:IHandoverSetting[];
  dropoffParentA:IHandoverSetting[];
  pickupParentB:IHandoverSetting[];
  dropoffParentB:IHandoverSetting[];

  visitDaysParentA:number[];
  visitDaysParentB:number[];
}

interface IProps extends WithStyles<typeof EditActionStyle> {
  family:IFamilyMember[];
  selectedDays:IDateRange[];
  scheduleEditBase:ISchedule|undefined; 
  scheduleEditPreview:ISchedule|undefined; 
  updatePreview:(schedule:ISchedule) => void;
  updateBase:(schedule:ISchedule) => void;
  close:(finished:boolean) => void;
}

const MIN_DAYVISIT_MINUTES = 15;

// a handover at school has no time of its own, so only visits with set times can be checked
const isTooShort = (start:IHandoverSetting, end:IHandoverSetting):boolean =>
  !start.atSchool && !end.atSchool
    && (end.hour*60 + end.minute) - (start.hour*60 + start.minute) < MIN_DAYVISIT_MINUTES;

class SleepAtParent extends React.Component<IProps, IState> {

  private timer = setTimeout(() => {return;}, 100);

  constructor(props: IProps) {
    super(props);
    
    const handovers = calculateHandoverDays(props.selectedDays, props.scheduleEditBase);
    const timePlace = getDefaultDays(props.scheduleEditBase);

    this.state = {
      pickupParentA: timePlace.parentATakesOverDayVisitStart,
      dropoffParentA:timePlace.parentBTakesOverDayVisitEnd,
      pickupParentB: timePlace.parentBTakesOverDayVisitStart,
      dropoffParentB:timePlace.parentATakesOverDayVisitEnd,
    
      visitDaysParentA:handovers.daysParentA,
      visitDaysParentB:handovers.daysParentB,
    };

    if (props.scheduleEditBase !== undefined) {
      props.updatePreview(applyChanges(props.scheduleEditBase, props.selectedDays, 
        this.state.pickupParentA, this.state.dropoffParentA, this.state.pickupParentB, this.state.dropoffParentB  ));
    }
  }

  public componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any): void {
    if (prevProps.selectedDays !== this.props.selectedDays ) {
      const handovers = calculateHandoverDays(this.props.selectedDays, this.props.scheduleEditBase);
      if (this.props.scheduleEditBase !== undefined) {
        this.props.updatePreview(applyChanges(this.props.scheduleEditBase, this.props.selectedDays, 
          this.state.pickupParentA, this.state.dropoffParentA, this.state.pickupParentB, this.state.dropoffParentB));
      }
      this.setState({visitDaysParentA:handovers.daysParentA, visitDaysParentB:handovers.daysParentB});
    }
  }

  public render() {
    const {classes, family, scheduleEditBase} = this.props;

    const school = scheduleEditBase?scheduleEditBase.school:undefined;
    const schoolAge = schoolAgeFromFamily(family);

    const dayvisits:JSX.Element[] = [];

    let totalChanges = 0;
    let hasTooShort = false;
    for (let index = 0; index < this.state.visitDaysParentA.length; index++) {
      const occurences = this.state.visitDaysParentA[index];
      totalChanges += occurences;
      if (occurences > 0 && scheduleEditBase !== undefined) {
        const tooShortA = isTooShort(this.state.pickupParentA[index], this.state.dropoffParentA[index]);
        hasTooShort = hasTooShort || tooShortA;

        dayvisits.push(<div className={classes.handoverDayDetails} key={"aday"+index}>
            <span style={{fontSize:'11px'}}>{tn.lang.calDayvisitAt}</span>
            <span className={classes.handoverGroupTitle}>
              {tn.lang.calDayvisitOnDay(tn.familyMemberName(scheduleEditBase.data.parentA,family), tn.lang.getWeekdayName(index))}
            </span>
          </div>);

        dayvisits.push(<ChangeTimePlaceDay 
          key={"apickup"+index}
          title={tn.lang.calDayvisitToFrom(tn.familyMemberName(scheduleEditBase.data.parentB,family),
            tn.familyMemberName(scheduleEditBase.data.parentA,family))}
          occurences={occurences}
          atSchool={this.state.pickupParentA[index].atSchool}
          school={school}
          schoolAge={schoolAge}
          loc={this.state.pickupParentA[index].location}
          hour={this.state.pickupParentA[index].hour}
          minute={this.state.pickupParentA[index].minute}
          defaultHour={11}
          update={(atSchool:boolean, loc:string, hour:number, minute:number, direct:boolean) => 
            this.update("pickupA", index, {atSchool,location:loc,hour,minute}, direct)}
        />);

        dayvisits.push(<ChangeTimePlaceDay
          key={"adropoff"+index}
          title={tn.lang.calDayvisitToFrom(tn.familyMemberName(scheduleEditBase.data.parentA,family),
            tn.familyMemberName(scheduleEditBase.data.parentB,family))}
          occurences={occurences}
          atSchool={this.state.dropoffParentA[index].atSchool}
          school={school}
          schoolAge={schoolAge}
          loc={this.state.dropoffParentA[index].location}
          hour={this.state.dropoffParentA[index].hour}
          minute={this.state.dropoffParentA[index].minute}
          defaultHour={13}
          error={tooShortA ? tn.lang.calDayvisitTooShort : undefined}
          update={(atSchool:boolean, loc:string, hour:number, minute:number, direct:boolean) => 
            this.update("dropoffA", index, {atSchool,location:loc,hour,minute}, direct)}
        />)
      }
    }

    for (let index = 0; index < this.state.visitDaysParentB.length; index++) {
      const occurences = this.state.visitDaysParentB[index];
      totalChanges += occurences;
      if (occurences > 0 && scheduleEditBase !== undefined) {
        const tooShortB = isTooShort(this.state.pickupParentB[index], this.state.dropoffParentB[index]);
        hasTooShort = hasTooShort || tooShortB;

        dayvisits.push(<div className={classes.handoverDayDetails} key={"bday"+index}>
            <span style={{fontSize:'11px'}}>{tn.lang.calDayvisitAt}</span>
            <span className={classes.handoverGroupTitle}>
              {tn.lang.calDayvisitOnDay(tn.familyMemberName(scheduleEditBase.data.parentB,family), tn.lang.getWeekdayName(index))}
            </span>
          </div>);

        dayvisits.push(<ChangeTimePlaceDay 
          key={"bpickup"+index}
          title={tn.lang.calDayvisitToFrom(tn.familyMemberName(scheduleEditBase.data.parentA,family),
            tn.familyMemberName(scheduleEditBase.data.parentB,family))}
          occurences={occurences}
          atSchool={this.state.pickupParentB[index].atSchool}
          school={school}
          schoolAge={schoolAge}
          loc={this.state.pickupParentB[index].location}
          hour={this.state.pickupParentB[index].hour}
          minute={this.state.pickupParentB[index].minute}
          defaultHour={11}
          update={(atSchool:boolean, loc:string, hour:number, minute:number, direct:boolean) => 
            this.update("pickupB", index, {atSchool,location:loc,hour,minute}, direct)}
        />);

        dayvisits.push(<ChangeTimePlaceDay
          key={"bdropoff"+index}
          title={tn.lang.calDayvisitToFrom(tn.familyMemberName(scheduleEditBase.data.parentB,family),
            tn.familyMemberName(scheduleEditBase.data.parentA,family))}
          occurences={occurences}
          atSchool={this.state.dropoffParentB[index].atSchool}
          school={school}
          schoolAge={schoolAge}
          loc={this.state.dropoffParentB[index].location}
          hour={this.state.dropoffParentB[index].hour}
          minute={this.state.dropoffParentB[index].minute}
          defaultHour={13}
          error={tooShortB ? tn.lang.calDayvisitTooShort : undefined}
          update={(atSchool:boolean, loc:string, hour:number, minute:number, direct:boolean) => 
            this.update("dropoffB", index, {atSchool,location:loc,hour,minute}, direct)}
        />)
      }
    }

    let helperText:JSX.Element|null = null;

    if (dayvisits.length === 0) {
      helperText = tn.lang.calDayvisitHelp;
    }

    return (<>
      <div className={classes.paneOptions} >
        <Button className={classes.paneOption} style={{textAlign: 'start'}}  startIcon={<BackArrowIcon />} classes={{text:classes.backButton}}
          onClick={() => {
          if (this.props.scheduleEditBase) {
            this.props.updatePreview(this.props.scheduleEditBase);  
          }
          this.props.close(false);
        }}>
          {tn.lang.back}
        </Button>
        <div className={classes.paneOption+" "+classes.paneCenter} > 
          <div style={{fontSize:'10px'}}>{""}</div>
        </div>
        <Button className={classes.paneOption} variant="contained" color="primary" style={{textAlign: 'end', marginRight:'10px'}} 
          disabled={totalChanges === 0 || hasTooShort} onClick={() => this.execute()} classes={{contained:classes.buttonContained}} >
          {tn.lang.save}
        </Button>
      </div>
      <div className={classes.pane}>
        {helperText}
        {dayvisits}
      </div>
      </>
    );
  }

  private execute() {
    if (this.props.scheduleEditBase) {
      this.props.updateBase(applyChanges(this.props.scheduleEditBase, this.props.selectedDays, 
        this.state.pickupParentA, this.state.dropoffParentA, this.state.pickupParentB, this.state.dropoffParentB));
      this.props.close(true);
    }
  }

  private update(side:"dropoffA"|"pickupA"|"dropoffB"|"pickupB", index:number, settings:IHandoverSetting, direct:boolean) {
    if (side === "pickupA") {
      const pickupParentA = [...this.state.pickupParentA];
      pickupParentA[index] = settings;
      this.setState({pickupParentA});
      if (this.props.scheduleEditBase) {
        this.updatePreview(direct, this.props.scheduleEditBase, this.props.selectedDays, 
          pickupParentA, this.state.dropoffParentA, this.state.pickupParentB, this.state.dropoffParentB);
      }
    } else if (side === 'dropoffA') {
      const dropoffParentA = [...this.state.dropoffParentA];
      dropoffParentA[index] = settings;
      this.setState({dropoffParentA});
      if (this.props.scheduleEditBase) {
        this.updatePreview(direct, this.props.scheduleEditBase, this.props.selectedDays, 
          this.state.pickupParentA, dropoffParentA, this.state.pickupParentB, this.state.dropoffParentB);
      }
    } else if (side === "pickupB") {
      const pickupParentB = [...this.state.pickupParentB];
      pickupParentB[index] = settings;
      this.setState({pickupParentB});
      if (this.props.scheduleEditBase) {
        this.updatePreview(direct, this.props.scheduleEditBase, this.props.selectedDays, 
          this.state.pickupParentA, this.state.dropoffParentA, pickupParentB, this.state.dropoffParentB);
      }
    } else if (side === 'dropoffB') {
      const dropoffParentB = [...this.state.dropoffParentB];
      dropoffParentB[index] = settings;
      this.setState({dropoffParentB});
      if (this.props.scheduleEditBase) {
        this.updatePreview(direct, this.props.scheduleEditBase, this.props.selectedDays, 
          this.state.pickupParentA, this.state.dropoffParentA, this.state.pickupParentB, dropoffParentB);
      }
    } 
  }

  private updatePreview(direct:boolean, schedule:ISchedule, selectedDays:IDateRange[], 
    pickupParentA:IHandoverSetting[], dropoffParentA:IHandoverSetting[], 
    pickupParentB:IHandoverSetting[], dropoffParentB:IHandoverSetting[]) {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.timer = setTimeout(() =>
      this.props.updatePreview(applyChanges(schedule, selectedDays, pickupParentA, dropoffParentA, pickupParentB, dropoffParentB))
      ,direct?0:500);
  }
}

function mapStateToProps(state: any) {

  return {
    family:state.family.family,
  };
}

export default connect(mapStateToProps)(withStyles(EditActionStyle)(SleepAtParent));



// WEBPACK FOOTER //
// ./src/components/calendar2/editPane/editActions/Dayvisit/Dayvisit.tsx